import { memo } from 'react'

import { ALERT_TYPES } from '../../config/constants'
import { ReactComponent as Attention } from '../../static/icons/attention.svg'
import { ReactComponent as Check } from '../../static/icons/check.svg'
import { ReactComponent as CrossIcon } from '../../static/icons/cross.svg'

import type { AlertProps } from './Alert.types'

function Alert(props: AlertProps) {
  const { message, options, style } = props

  const baseClassName = 'flex items-center justify-between px-4 py-3 rounded-md'
  let alertTypeClassName = ''

  if (options.type === ALERT_TYPES.SUCCESS) {
    alertTypeClassName = 'bg-green-100 text-green-700'
  } else if (options.type === ALERT_TYPES.ERROR) {
    alertTypeClassName = 'bg-red-100 text-red-700'
  }

  const className = `${baseClassName} ${alertTypeClassName}`

  return (
    <div className={className} style={style}>
      <div className="flex items-center space-x-2">
        {options.type === ALERT_TYPES.SUCCESS && (
          <Check height={20} width={20} className="text-green-700" />
        )}
        {options.type === ALERT_TYPES.ERROR && (
          <Attention height={20} width={20} className="text-red-700" />
        )}
        <span>{message}</span>
      </div>
      <button
        className="text-gray-500 hover:text-gray-700 ml-2"
        onClick={props.close}
      >
        <CrossIcon className="text-green-700" />
      </button>
    </div>
  )
}

export default memo(Alert)
